import React, { FC } from 'react';
import { Load } from '../../../types';
import { DraftLoadProvider } from '../hooks/draft-load-context';
import { EditCreateLoadForm } from './edit-create-load-form';
import { typedCreateLoad } from '../utils/typed-create-load';
import { useCompanyId } from '../../../app/agistics-context';

interface EditCreateLoadProps {
    inputLoad: Load | null;
    onSubmit: () => void;
    onBack?: () => void;
}

export const EditCreateLoad: FC<EditCreateLoadProps> = (props) => {
    const { inputLoad, onSubmit, onBack } = props;
    const companyId = useCompanyId();

    return (
        <DraftLoadProvider
            inputLoad={inputLoad ? inputLoad : typedCreateLoad(companyId, false)}
        >
            <EditCreateLoadForm
                onSubmit={onSubmit}
                onBack={onBack}
            />
        </DraftLoadProvider>
    );
};
